import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateListResource } from '../../../lib/query/invalidateResource';
import { deleteCampaign } from '../api/campaigns';
import { notification } from 'antd';

export function useDeleteCampaign(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteCampaign(id),
    onSuccess: () => {
      notification.success({ message: 'Campaign deleted successfully' });
      invalidateListResource(queryClient, 'campaigns');
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      notification.error({ message: 'Failed to delete campaign' });
    },
  });
}
